// extracted by mini-css-extract-plugin
export default {"FieldLabel":"FieldLabel_FieldLabel__hMClG","FieldLabel--large":"FieldLabel_FieldLabel--large__EfJQB"};